import React from 'react'

const LEGEND = [
  { label: '80–100', color: '#22c55e' },
  { label: '65–79',  color: '#84cc16' },
  { label: '50–64',  color: '#f59e0b' },
  { label: '35–49',  color: '#f97316' },
  { label: '0–34',   color: '#ef4444' },
]

export default function ScanResultsPanel({ scanResult, scanLoading, scanError }) {
  if (scanLoading) {
    return (
      <div className="loading-overlay">
        <div className="spinner" />
        <span>Running area scan…</span>
        <span style={{ fontSize: 11 }}>This may take a moment for large areas.</span>
      </div>
    )
  }

  if (scanError) {
    return <div className="alert alert-danger">{scanError}</div>
  }

  if (!scanResult) return null

  const meta = scanResult.metadata ?? {}
  const stats = meta.score_stats ?? {}

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div className="card">
        <div className="card__title">Scan Results</div>
        <table className="data-table">
          <tbody>
            <tr><td>Technology</td><td>{meta.technology}</td></tr>
            <tr><td>Resolution</td><td>{meta.resolution_km} km</td></tr>
            <tr><td>Points scanned</td><td>{meta.total_points}</td></tr>
            <tr><td>Successful</td><td>{meta.successful_points}</td></tr>
            {stats.max != null && (
              <tr><td>Score range</td><td>{stats.min} – {stats.max}</td></tr>
            )}
            {stats.mean != null && (
              <tr><td>Mean score</td><td>{stats.mean}</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="card">
        <div className="card__title">Score Legend</div>
        <div className="legend">
          {LEGEND.map(l => (
            <div key={l.label} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <span className="legend-swatch" style={{ background: l.color }} />
              <span style={{ fontSize: 11 }}>{l.label}</span>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 8, fontSize: 11, color: 'var(--color-muted)' }}>
          Circles on the map show overall suitability score (0–100).
          Click any point to run a full assessment.
        </div>
      </div>
    </div>
  )
}
